import { DText, Flex } from "../../../../../styles/CommonStyles";
import CheckBox from "../../../../common/input/CheckBox";
import { SOCKET_URL } from "../../../../../core/constants/urls";
import { UpdateCoinTagWrapper } from "../../../../../styles/main/setting";

const UpdateCoinTag = ({
    coin,               // ticker string like "BTC-USDT" or "EURUSD"
    activeCoins = [],   // array of tickers currently active
    onCoinStateChange,  // handler
    isPair = false,     // if true => render as pair image
    tickerCase          // "crypto" or "forex"
}) => {
    const isActive = activeCoins?.includes(coin);

    const renderPairImage = () => {
        if (tickerCase === "forex") {
            return (
                <img
                    src={`${SOCKET_URL}assets/icon/${coin.toLowerCase()}.png`}
                    alt={coin}
                    width="28px"
                    height="28px"
                />
            );
        }

        const [base, quote] = coin.split("-");
        return (
            <div className="relative" style={{ width: 42 }}>
                <img
                    src={`${SOCKET_URL}assets/icon/${base?.toLowerCase()}.png`}
                    width="24px"
                    height="24px"
                    alt={base}
                    className="absolute rtl:left-0 ltr:right-0 top-0"
                />
                <img
                    src={`${SOCKET_URL}assets/icon/${quote?.toLowerCase()}.png`}
                    width="24px"
                    height="24px"
                    alt={quote}
                />
            </div>
        );
    };

    return (
        <UpdateCoinTagWrapper active={isActive}>
            <Flex fw fh justify="space-between">
                <CheckBox
                    active={isActive}
                    onClick={() => onCoinStateChange(coin, isActive)}
                />
                <Flex align="center">
                    {isPair ? renderPairImage() : (
                        <img
                            src={`${SOCKET_URL}assets/icon/${coin.toLowerCase()}.png`}
                            alt={coin}
                            width="28px"
                            height="28px"
                        />
                    )}
                    <DText main style={{ margin: "0 4px" }}>
                        {coin.toUpperCase()}
                    </DText>
                </Flex>
            </Flex>
        </UpdateCoinTagWrapper>
    );
};

export default UpdateCoinTag;
